const careGuidanceMap = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'surgery-support': 'surgical_decision',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'expert-medical': 'medical_guidance',
};

export default careGuidanceMap;
